// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documentsTable__previewImage {
    position: relative;
    width: 58px;
    height: 73px;
    border: 2px solid #e0e0e0;
    z-index: 100;
}
.documentsTable__preview--big {
    border: 2px solid #a0a0a0;
}

.documentsTable__previewContainer {
    position: relative;
    width: 100%;
    height: 100%;
}

.documentsTable__preview--odd {
    margin-left: 50%;
}
.documentsTable__previewCell {
    overflow: visible !important;
}
.documentsHistory {
    padding: 0 50px;
}
.documentsTable__supersedeList {
    width: 100%;
    position: relative;
    overflow: auto;
    max-height: 75vh;
}
.documentsTable__typography--breakLines {
    overflow-wrap: break-word;
    white-space: pre;
    text-wrap: wrap;
}

.documentsTable_dropFiles {
    display: flex;
}

.documentsTable_dropFiles--readonly {
    background-color: unset;
    cursor: unset;
}

.documentsTable_dropFiles--over {
    background-color: #f5f5f5f5;
    border-radius: 15px;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./../mirage/src/components/documentsTable/documentsTable.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":[".documentsTable__previewImage {\n    position: relative;\n    width: 58px;\n    height: 73px;\n    border: 2px solid #e0e0e0;\n    z-index: 100;\n}\n.documentsTable__preview--big {\n    border: 2px solid #a0a0a0;\n}\n\n.documentsTable__previewContainer {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.documentsTable__preview--odd {\n    margin-left: 50%;\n}\n.documentsTable__previewCell {\n    overflow: visible !important;\n}\n.documentsHistory {\n    padding: 0 50px;\n}\n.documentsTable__supersedeList {\n    width: 100%;\n    position: relative;\n    overflow: auto;\n    max-height: 75vh;\n}\n.documentsTable__typography--breakLines {\n    overflow-wrap: break-word;\n    white-space: pre;\n    text-wrap: wrap;\n}\n\n.documentsTable_dropFiles {\n    display: flex;\n}\n\n.documentsTable_dropFiles--readonly {\n    background-color: unset;\n    cursor: unset;\n}\n\n.documentsTable_dropFiles--over {\n    background-color: #f5f5f5f5;\n    border-radius: 15px;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
